export const latestTicker = [
  '片场花絮前后对照合集 · 第 12 次修订已归档',
  '采访原声逐句稿 · 新增 9 处时间戳标注',
  '前后对照图鉴 · 收录第 200 组并排影像',
  '数据与凭证台账 · 新增公示口径变化对照表',
  '读者投稿线索 · 本期进入待核阶段 23 条',
  '更新日志 · 本周共归档 164 条条目',
];

export const quickEntries = [
  { label: '最新实锤', href: '#timeline', icon: 'ri-flashlight-line' },
  { label: '话题墙', href: '#topics', icon: 'ri-price-tag-3-line' },
  { label: '合集索引', href: '#collections', icon: 'ri-stack-line' },
  { label: '关键词检索', href: '#keywords', icon: 'ri-search-eye-line' },
];

export const navLinks = [
  { label: '首页', href: '#top' },
  { label: '话题墙', href: '#topics' },
  { label: '合集索引', href: '#collections' },
  { label: '时间线', href: '#timeline' },
  { label: '关键词', href: '#keywords' },
];

export const heroStats = [
  { value: '2,816', label: '已归档条目' },
  { value: '164', label: '在追话题' },
  { value: '38', label: '精选合集' },
  { value: '每日 3 更', label: '更新节奏' },
];

export const topicTags = [
  { name: '前后对照', count: 152 },
  { name: '片场记录', count: 128 },
  { name: '公开影像', count: 110 },
  { name: '采访口径', count: 96 },
  { name: '读者投稿', count: 93 },
  { name: '时间线梳理', count: 88 },
  { name: '路透线索', count: 79 },
  { name: '通稿差异', count: 74 },
  { name: '同框对比', count: 68 },
  { name: '花絮存档', count: 63 },
  { name: '数据台账', count: 57 },
  { name: '素材溯源', count: 52 },
  { name: '声明对照', count: 45 },
  { name: '更新日志', count: 41 },
];

export const collections = [
  {
    id: 'C-01',
    title: '片场反差影像集',
    desc: '从开机路透到收工花絮，按时间轴归档的 86 条影像线索，前后状态对照一目了然。',
    count: 86,
    tags: ['片场记录', '花絮对比', '影像存档'],
    image:
      'https://readdy.ai/api/search-image?query=Moody%20behind%20the%20scenes%20film%20set%20with%20scattered%20director%20chairs%20and%20studio%20lighting%20rigs%2C%20deep%20shadows%2C%20crimson%20accent%20light%2C%20cinematic%20editorial%20photography%2C%20heavy%20film%20grain%2C%20no%20people%2C%20no%20text%2C%20dark%20charcoal%20and%20warm%20amber%20tones%2C%20high%20contrast%20dramatic%20composition&width=800&height=600&seq=hlfc-col-01&orientation=landscape',
  },
  {
    id: 'C-02',
    title: '采访原声对照',
    desc: '把公开采访逐句拆解，标记每一次口径变化，附时间戳与出处，方便自行核对。',
    count: 64,
    tags: ['原声逐句', '口径变化', '时间戳'],
    image:
      'https://readdy.ai/api/search-image?query=Vintage%20microphone%20and%20tangled%20audio%20cables%20on%20a%20dark%20wooden%20table%20under%20a%20single%20warm%20spotlight%2C%20editorial%20still%20life%20photography%2C%20deep%20shadows%20with%20red%20rim%20light%2C%20minimal%20composition%2C%20no%20text%2C%20cinematic%20moody%20atmosphere%2C%20film%20grain%20texture&width=800&height=600&seq=hlfc-col-02&orientation=landscape',
  },
  {
    id: 'C-03',
    title: '前后对照图鉴',
    desc: '同一场景不同时间点的公开影像并排陈列，也是黑料反差深扒时最常回看的一册。',
    count: 200,
    tags: ['并排对照', '公开影像', '视觉笔记'],
    image:
      'https://readdy.ai/api/search-image?query=Split%20composition%20of%20old%20crumpled%20photographs%20arranged%20on%20a%20charcoal%20paper%20surface%2C%20dramatic%20overhead%20lighting%2C%20duotone%20warm%20amber%20and%20crimson%20accents%2C%20heavy%20film%20grain%20texture%2C%20artistic%20collage%2C%20no%20people%2C%20no%20text%2C%20high%20contrast%20editorial%20photography&width=800&height=600&seq=hlfc-col-03&orientation=landscape',
  },
  {
    id: 'C-04',
    title: '数据与凭证台账',
    desc: '把可公开核对的数字、通稿与公示信息整理成台账，实锤与否交由读者自行判断。',
    count: 57,
    tags: ['数据台账', '公开凭证', '逻辑链'],
    image:
      'https://readdy.ai/api/search-image?query=Stack%20of%20printed%20documents%20charts%20and%20evidence%20folders%20on%20a%20dark%20desk%20under%20harsh%20side%20light%2C%20scattered%20paper%20clips%2C%20film%20grain%2C%20muted%20warm%20tones%20with%20crimson%20highlights%2C%20investigative%20editorial%20still%20life%2C%20no%20text%2C%20no%20people%2C%20high%20contrast&width=800&height=600&seq=hlfc-col-04&orientation=landscape',
  },
];

export const timelineEntries = [
  {
    date: '2026.09.10',
    time: '14:20',
    tag: '实锤',
    title: '片场花絮前后对照合集完成第 12 次修订',
    desc: '本轮补充 14 组同一机位的公开影像，并重新校准拍摄日期，前后状态差异可直接并排比对。',
  },
  {
    date: '2026.09.09',
    time: '21:05',
    tag: '更新',
    title: '采访原声逐句稿新增 9 处时间戳标注',
    desc: '把两段公开采访对齐到同一时间轴，标出措辞发生变化的具体位置，出处链接一并附上。',
  },
  {
    date: '2026.09.08',
    time: '10:40',
    tag: '归档',
    title: '「前后对照图鉴」收录第 200 组并排影像',
    desc: '图鉴达到第 200 组，本期按场景类型重新分区，历史条目同步完成一次结构性梳理。',
  },
  {
    date: '2026.09.06',
    time: '19:30',
    tag: '线索',
    title: '读者提交的公开通稿比对线索进入待核阶段',
    desc: '共收到 31 条投稿，其中 23 条通过初步查重，正在补齐可公开核对的出处与时间信息。',
  },
  {
    date: '2026.09.05',
    time: '09:15',
    tag: '深扒',
    title: '数据台账新增公示口径变化对照表',
    desc: '把前后两份公开公示的口径差异整理成表格，保留原始字段，避免二次转述造成偏差。',
  },
  {
    date: '2026.09.03',
    time: '22:50',
    tag: '合集',
    title: '「片场反差影像集」按季度重新分区归档',
    desc: '影像集从单条时间线改为季度分区，方便按拍摄周期定位，检索平均耗时下降约四成。',
  },
];

export const keywordGroups = [
  {
    group: 'High Frequency',
    title: '高频检索词',
    words: ['黑料反差', '黑料反差爆料', '黑料反差实锤', '黑料反差深扒', '前后对照', '时间线梳理'],
  },
  {
    group: 'Content Types',
    title: '内容形态',
    words: ['合集索引', '话题墙', '影像存档', '原声逐句', '数据台账', '更新日志'],
  },
  {
    group: 'Timeline',
    title: '时间维度',
    words: ['本周更新', '本月归档', '季度合集', '年度总览', '最新实锤', '历史线索'],
  },
];

export const footerGroups = [
  {
    title: '内容分区',
    links: [
      { label: '话题墙', href: '#topics' },
      { label: '合集索引', href: '#collections' },
      { label: '更新时间线', href: '#timeline' },
      { label: '关键词索引', href: '#keywords' },
    ],
  },
  {
    title: '热门合集',
    links: [
      { label: '片场反差影像集', href: '#collections' },
      { label: '采访原声对照', href: '#collections' },
      { label: '前后对照图鉴', href: '#collections' },
      { label: '数据与凭证台账', href: '#collections' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '更新说明', href: '#top' },
      { label: '内容准则', href: '#top' },
      { label: '线索投稿', href: '#top' },
      { label: '免责声明', href: '#top' },
    ],
  },
];